import useApi from '../../../services/useApi'
import {useEffect, useState} from 'react'

const useGetQuantityIncomingDetails = (sku: any) => {
  const Api = useApi()
  const [data, setData] = useState<any[]>([])

  const {data: variantData, isFetching} = Api.useGetQuery(
    `/analytics/replenishment/incoming/quantity`,
    {
      queryId: `product-variant-quantity-incoming-${sku}`,
      filters: {sku: sku},
      isToast: false,
    },
    {
      enabled: !!sku,
    }
  )

  useEffect(() => {
    if (variantData?.data?.length > 0) {
      setData(variantData.data)
    }
  }, [variantData])

  const onSortingChange = (sortBy: keyof (typeof data)[0], sortDirection: 'asc' | 'desc') => {
    setData((prevData) => {
      return [...prevData].sort((a, b) => {
        if (a[sortBy] < b[sortBy]) return sortDirection === 'asc' ? -1 : 1
        if (a[sortBy] > b[sortBy]) return sortDirection === 'asc' ? 1 : -1
        return 0
      })
    })
  }

  return {
    quantityIncomingDetails: data,
    isLoading: isFetching,
    onSortingChange,
  }
}

export default useGetQuantityIncomingDetails
